import { useState, useEffect } from "react";
import { TextField, Typography, Stack } from "@mui/material";
import PropTypes from 'prop-types';
import SelectInfo from "./selectInfo";

function InfoPersonnelles({ liste_structure, liste_role, onInfoPersoChange, triggerResetInfoPerso }) {

  const [info_perso, setInfo_perso] = useState({
    prenom: '',
    nom: '',
    telephone: '',
    mail: '',
    structure: '',
    role: ''
  });

  //---------------------------------------------------------------------------
  // mise à jour des données dans le composant parent
  //---------------------------------------------------------------------------
  useEffect(() => {
    onInfoPersoChange(info_perso);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [info_perso]);

  //---------------------------------------------------------------------------
  // reset des info personneles
  //---------------------------------------------------------------------------
  useEffect(() => {
    if (triggerResetInfoPerso) {
      setInfo_perso({
        prenom: '',
        nom: '',
        telephone: '',
        mail: '',
        structure: '',
        role: ''
      });
    }
  }, [triggerResetInfoPerso]);

  //---------------------------------------------------------------------------
  // HMI
  //---------------------------------------------------------------------------
  return (
    <Stack spacing={1} alignItems={'center'} sx={{ width: '100%' }}>
      <Typography variant="h4" align="center">
        Mes informations personnelles
      </Typography>

      <TextField
        size="small"
        label="Entrez votre prénom"
        variant="outlined"
        fullWidth
        value={info_perso.prenom}
        onChange={(event) => { setInfo_perso({ ...info_perso, prenom: event.target.value }); }}
        margin="normal"
        required
      />

      <TextField
        size="small"
        label="Entrez votre nom"
        variant="outlined"
        fullWidth
        value={info_perso.nom}
        onChange={(event) => { setInfo_perso({ ...info_perso, nom: event.target.value }); }}
        margin="normal"
        required
      />

      <TextField
        size="small"
        label="Entrez votre N° de téléphone"
        variant="outlined"
        fullWidth
        value={info_perso.telephone}
        onChange={(event) => { setInfo_perso({ ...info_perso, telephone: event.target.value }); }}
        margin="normal"
        required
      />

      <TextField
        size="small"
        label="Entrez votre mail"
        variant="outlined"
        fullWidth
        value={info_perso.mail}
        onChange={(event) => { setInfo_perso({ ...info_perso, mail: event.target.value }); }}
        margin="normal"
        required
      />

      <SelectInfo
        label="Choisissez votre structure"
        value={info_perso.structure}
        onChange={(event) => { setInfo_perso({ ...info_perso, structure: event.target.value }); }}
        items={liste_structure} />

      <SelectInfo
        label="Que vais-je faire pendant le festival"
        value={info_perso.role}
        onChange={(event) => { setInfo_perso({ ...info_perso, role: event.target.value }); }}
        items={liste_role} />
    </Stack>

  );
};

InfoPersonnelles.propTypes = {
  liste_structure: PropTypes.any.isRequired,
  liste_role: PropTypes.any.isRequired,
  onInfoPersoChange: PropTypes.any.isRequired,
  triggerResetInfoPerso: PropTypes.any.isRequired
};

export default InfoPersonnelles;